import React from 'react';
import styles from './triangle.module.scss';
import { TriangleSvg } from 'shared/svg';

interface ITriangleProps {
  isRotated: boolean;
}
export const Triangle: React.FC<ITriangleProps> = ({ isRotated }) => {
  return (
    <div
      className={`${styles.triangle} ${isRotated ? styles['triangle--rotated'] : ''}`}
    >
      <TriangleSvg />
    </div>
  );
};
